/* O relatório em markdown do agente, no fim da sessão, buscado só quando alguém abre.
 *
 * Sem endpoint novo: é o `/api/reports/latest` que a aba Relatórios já consome, com a
 * mesma chave de cache. Assim o markdown fica fora do payload principal do Margin
 * Finder e não volta a viajar para quem já passou por /relatorios. */

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { ReportsLatestPayload } from "../../lib/api";
import { Empty, ErrorState, Markdown, Skeleton } from "../../components/ui";

export function RelatorioEmTexto({ userId, agentId }: { userId: string; agentId: string }) {
  const [aberto, setAberto] = useState(false);
  const reports = useQuery({
    queryKey: ["reports-latest"],
    queryFn: () => api<ReportsLatestPayload>("/api/reports/latest"),
    // Mesmas opções da aba Relatórios, obrigatoriamente: staleTime é por
    // observador, e um 60s aqui faria ESTA montagem revalidar a chave inteira.
    staleTime: Infinity,
    gcTime: 12 * 60 * 60_000,
    retry: false,
    enabled: aberto,
  });
  const texto = reports.data?.users
    .find((u) => u.user_id === userId)?.agents[agentId]?.user_report;

  return (
    <details className="mf-relatorio" onToggle={(e) => setAberto(e.currentTarget.open)}>
      <summary>ver o relatório em texto</summary>
      {aberto && reports.isPending && <Skeleton rows={6} />}
      {reports.error && (
        <ErrorState error={reports.error} onRetry={() => reports.refetch()} />
      )}
      {reports.data && (texto
        ? <Markdown text={texto} />
        : <Empty>Sem relatório em texto para este usuário.</Empty>)}
    </details>
  );
}
